import React, { useState, useEffect, useCallback } from "react";
import config from "../../Config";
import axios from "axios";
import SecurityMenu from "./SecurityMenu";
import Spinner from "react-bootstrap/Spinner";
import { useParams, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RightsCheck from "../General/RightsCheck";

function RightsAssignment() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(true);
  const [listOfLedger, setListOfLedger] = useState([]);
  const [UserGroup, setUserGroup] = useState({});
  const [loadingItem, setLoadingItem] = useState(null);

  const [ControllerName, setControllerName] = useState("");
  const [FunctionName, setFunctionName] = useState("");
  const [FullURL, setFullURL] = useState("");
  const [HasRight, setHasRight] = useState("All");

  const params = useParams();
  const GroupID = params.id;

  const loadPages = useCallback(() => {
    if (!GroupID) {
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Members/GetAllPagesByGroupID",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        ID: GroupID,
        ControllerName,
        FunctionName,
        FullURL,
        HasRight,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setListOfLedger(response.data.ListofRecords || []);
        } else {
          setListOfLedger([]);
          if (response.data.status_message) {
            toast.error(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        setListOfLedger([]);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  }, [
    AccessKey,
    UserID,
    MemberType,
    GroupID,
    ControllerName,
    FunctionName,
    FullURL,
    HasRight,
  ]);

  useEffect(() => {
    document.title = "Group Rights Assignment";
    if (!GroupID) {
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "Members/GetUserGroupByID",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        ID: GroupID,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setUserGroup(response.data.UserGroup || {});
        }
      })
      .catch(function () {
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  }, [GroupID, AccessKey, UserID, MemberType]);

  useEffect(() => {
    const timer = setTimeout(() => {
      loadPages();
    }, 350);
    return () => clearTimeout(timer);
  }, [loadPages]);

  const UpdateRights = (e, controllerPageId) => {
    const checked = e.target.checked;
    setLoadingItem(controllerPageId);

    setListOfLedger((prev) =>
      prev.map((row) =>
        row.ID === controllerPageId ? { ...row, hasRights: checked } : row
      )
    );

    axios({
      method: "post",
      url: config.base_url + "Members/UpdateGroupRight",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        ControllerID: controllerPageId,
        GroupID: parseInt(GroupID, 10),
        hasRights: checked,
      },
    })
      .then(function (response) {
        setLoadingItem(null);
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          setListOfLedger((prev) =>
            prev.map((row) =>
              row.ID === controllerPageId
                ? { ...row, hasRights: !checked }
                : row
            )
          );
          toast.error(
            response.data.status_message || "Failed to update rights.",
            { position: toast.POSITION.TOP_RIGHT }
          );
        }
      })
      .catch(function () {
        setLoadingItem(null);
        setListOfLedger((prev) =>
          prev.map((row) =>
            row.ID === controllerPageId ? { ...row, hasRights: !checked } : row
          )
        );
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => (
        <tr key={item.ID || index}>
          <td>{count++}</td>
          <td>{item.ID}</td>
          <td>{item.ControllerName}</td>
          <td>{item.FunctionName}</td>
          <td>{item.FullURL}</td>
          <td>{item.Details}</td>
          <td className="text-center">
            {loadingItem === item.ID ? (
              <Spinner animation="grow" size="sm" />
            ) : (
              <div className="form-check d-inline-block">
                <input
                  className="form-check-input"
                  checked={!!item.hasRights}
                  type="checkbox"
                  onChange={(ev) => UpdateRights(ev, item.ID)}
                  aria-label={`Rights for ${item.ControllerName} ${item.FunctionName}`}
                />
              </div>
            )}
          </td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan="7">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No pages found for the selected filters.
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <SecurityMenu />
      <ToastContainer />
      <RightsCheck />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Security/SecurityDashboard">Security</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Group Rights
                  </li>
                </ol>
              </nav>
              <div className="page-title">
                Rights Assignment for {UserGroup.GroupName || `Group #${GroupID}`}
              </div>
              <p className="small text-muted mb-0">
                New routes are auto-registered on first visit (Controller + Action from URL).
                Grant other groups here; the first visiting group receives access automatically.
              </p>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/Security/GroupManagement"
                  className="button button-white button-icon"
                >
                  Manage Groups
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card mb-2">
            <div className="card-body p-md-4">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label>Controller</label>
                    <input
                      type="text"
                      className="form-control"
                      value={ControllerName}
                      onChange={(e) => setControllerName(e.target.value)}
                      placeholder="Contains..."
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label>Action</label>
                    <input
                      type="text"
                      className="form-control"
                      value={FunctionName}
                      onChange={(e) => setFunctionName(e.target.value)}
                      placeholder="Contains..."
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label>URL</label>
                    <input
                      type="text"
                      className="form-control"
                      value={FullURL}
                      onChange={(e) => setFullURL(e.target.value)}
                      placeholder="Contains..."
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-3">
                    <label>Assigned</label>
                    <select
                      className="form-select"
                      onChange={(e) => setHasRight(e.target.value)}
                      value={HasRight}
                    >
                      <option value="All">All</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body table_card">
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>ID</th>
                    <th>Controller</th>
                    <th>Action</th>
                    <th>URL</th>
                    <th>Details</th>
                    <th className="text-center">Granted</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        <Spinner animation="border" role="status" />
                      </td>
                    </tr>
                  ) : (
                    renderLedger()
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RightsAssignment;
